import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env';
import { Observable } from 'rxjs';

export interface DatosUsuarioRequest {
  tipoDocumento: string;
  numeroDocumento: string;
  codigoPlanilla: string;
  regimenLaboral: string;
  codigoRed: string;
  correo: string;
}

export interface TokenResponse {
  token: string;
  url: string;
}

@Injectable({
  providedIn: 'root'
})
export class SeguroVidaService {

  private readonly URL = `${environment.apiUrl}/seguros-vida`;

  constructor(
    private http: HttpClient
  ) { }

  generarToken(dto: DatosUsuarioRequest): Observable<TokenResponse> {
    return this.http.post<TokenResponse>(`${this.URL}/generar-token`, dto);
  }

}
